import { render, staticRenderFns } from "./settingClean.vue?vue&type=template&id=4d10d971"
import script from "./settingClean.vue?vue&type=script&lang=js"
export * from "./settingClean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports